import React from "react";

import Icon from "Trackalyze/Icon";

const GPXIcon = (props) => {
  return (
    <div data-gpx-type={props.type} data-gpx-id={props.id} className="gpx-icon">
      {(props.id === "ascent" || props.id === "descent") && (
        <Icon symbol="arrow_upward" className="gpx-icon_overlay" />
      )}
      <Icon symbol={props.symbol} size={props.size || "m"} />
    </div>
  );
};

export default GPXIcon;
